import moment from 'moment';
import configs from 'configs';

class Utils {

  /**
   * URL params parser
   * @param {*} props 
   */
  static params(props) {
    var _default = {
      get: function () { return null; }
    }
    if (!props || !props.location) return _default;
    const search = props.location.search;
    if (!search) return _default;
    const params = new URLSearchParams(search);
    return params;
  }

  /**
   * Humalize the datetime format
   * @param {*} props 
   */
  static formalizeDatetime(date) {
    return moment(date).format("Do MMM YYYY, HH:mm");
  }

  /**
   * Get link https://rinkeby.etherscan.io/tx/<txId>
   */
  static etherScan(netId, tx) {
    netId = netId.toString();
    var network = '';
    switch (netId) {
      case '1':
        network = '';
        break;
      case '3':
        network = 'ropsten.';
        break;
      case '4':
        network = 'rinkeby.';
        break;
      case '42':
        network = 'kovan.';
        break;
      case '5':
        network = 'goerli.';
        break;
      default:
        network = '';
    }
    return 'https://' + network + 'etherscan.io/tx/' + tx;
  }

  static viewEtherscan(txId) {
    window.open(this.etherScan(configs.eth.NETWORK.ID, txId), "_blank");
  }
}

export default Utils;